import { sheetV1 } from "@otto-ec/otto-components/sheet";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { event } from "@otto-ec/global-resources/event";

const SHEET_ID = "sponsoredDealSheet";
const DEAL_DATA_CLASS = `.js_ft9_deal_data`;

function getRuleFromAvContent(): string {
  const avContent = document.getElementById("avContent");
  if (avContent) {
    return avContent.dataset.rule ?? "";
  }
  return "";
}

type SponsoredSheetData = {
  variationId: string;
  dealId: string;
};

function openSheet(event: Event) {
  if (!event.target || !(event.target instanceof Element)) return;

  const dealData = getDealData(event.target);
  if (!dealData) return;

  const url = new URL(`/benefit-sheet/sheet/listProductCampaignFlag/${dealData.dealId}`, window.location.origin);
  url.searchParams.set("variationId", dealData.variationId);
  url.searchParams.set("contextDreson", getRuleFromAvContent());

  sheetV1.create({
    id: SHEET_ID,
    url: url.pathname + url.search,
  });

  sheetV1.open(SHEET_ID);
}

function getDealData(target: Element): SponsoredSheetData | undefined {
  const dealData = target.closest<HTMLElement>(DEAL_DATA_CLASS);
  if (!dealData) {
    return;
  }

  const { dealId, variationId } = dealData.dataset;
  if (!dealId || !variationId) {
    return;
  }

  return {
    dealId,
    variationId,
  };
}

function registerSponsoredDealSheetClick() {
  const delegationElement = document.querySelectorAll<HTMLElement>(".find_tile__productImageContainer");
  delegationElement.forEach((el) => {
    event.delegate(el, "click", `${DEAL_DATA_CLASS} > .find_tile__deal`, openSheet);
  });
}

export function registerSponsoredDealSheet() {
  eventQBus.on("ftfind.tile.loaded", registerSponsoredDealSheetClick);
  eventQBus.on("ftfind.tilelist.restored", registerSponsoredDealSheetClick);
  registerSponsoredDealSheetClick();
}
